import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {contentToText} from '../../../utils/helpers.jsx';
import PieChart from '../../charting/PieChart/PieChart.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import Inset from '../../Inset/Inset.jsx';
import PictureFrame from '../../PictureFrame/PictureFrame.jsx';
import CoveredVideoPlayer from '../../CoveredVideoPlayer/CoveredVideoPlayer.jsx';
const chartstyles= {
    width   : "100%",
    height  : "0.85w",
    paddingLeft : 50,
    paddingRight: 50,
    paddingTop: 0,
    paddingBottom: 0
};


const piedata = {
    data: [
        {
            name: "Maritime",
            value: 42,
            color: "#009688"
        },
        {
            name: "Civil aviation",
            value: 1,
            color: "#e5ce89"
        },
        {
            name: "Public electricity generation",
            value: 9,
            color: "#e5982b"
        },
        {
            name: "Road transport",
            value: 21,
            color: "#5b0003"
        },
        {
            name: "Other",
            value: 26,
            color: "#cccccc"
        }
    ]
}

let componentRegistry = {
    "breakdown": (<div className="hongkong-breakdown"><SubInset hed="Hong Kong PM2.5 contribution by sector"
        source="Source: Hong Kong Environmental Protection Department 2013 Air Pollutant Emission Inventory"
        >
            <PieChart {...chartstyles} {...piedata}>
                <div style={{display:"table",width:"100%",height:"100%",textAlign:"center"}}>
                    <div style={{display:"table-cell",verticalAlign:"middle"}}>
                        <strong>Total:</strong><br/>
                        4,740 tonnes
                    </div>
                </div>
            </PieChart>
        </SubInset></div>)
}




export default (props) => {
    return (<div className="container body-text">
        <div className="section">
            <div className="row">
                <div className="col l8 push-l4">
                    <h3>Shipping and Your Health</h3>
                    <div style={{marginBottom:"45px"}}> 
                        <PictureFrame caption="Hong Kong is the first port in Asia to mandate fuel switching in its waters, but is the measure too little too late?">  
                            <CoveredVideoPlayer slug="20160519am-shipping-hongkong">
                                <img style={{width:"100%"}} src="images/video1-poster.jpg" />
                            </CoveredVideoPlayer>
                        </PictureFrame>
                    </div>
                    <Markdown>
                        {contentToText(content['shipping-and-your-health'],componentRegistry)}
                    </Markdown>
                </div>
            </div>
        </div>
    </div>)   
}




// WEBPACK FOOTER //
// ./src/js/components/special/HealthIntro/HealthIntro.jsx